import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { DateParserFormatter } from '@services/date-parser';
import { DropdownItem } from '../dropdown/dropdown.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

type HourForm = {
    from: FormControl<string>;
};

@UntilDestroy()
@Component({
    selector: 'app-hour-picker',
    templateUrl: './hour-picker.component.html',
    styleUrls: ['./hour-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => HourPickerComponent),
            multi: true
        },
        { provide: NgbDateParserFormatter, useClass: DateParserFormatter }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HourPickerComponent implements OnInit, ControlValueAccessor {
    /**
     * Whether not not to use the 12 hour format (AM/PM) instead of 24 hour format. Defaults to true
     */
    //@Input() public meridian = true;
    @Input() public disabled = false;
    @Input() public placeholder: string;

    public hourForm: FormGroup<HourForm>;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    public onTouched = (): void => {};

    public hours: DropdownItem<string>[] = [];
    public hourRange: string;

    public ngOnInit(): void {
        this.initForm();
        this.initDropdownItems();
    }

    public writeValue(value: string) {
        if (!this.disabled && value) {
            this.hourForm.setValue({ from: value }, { emitEvent: false });
            // const isValid = TimeHelper.isValidHourRange(value);

            // if (isValid) {
            //     const chunks = value.split('-');
            //     const from = chunks[0];
            //     const to = chunks[1];

            //     this.hourRange = value;
            //     this.hourRangeForm.setValue({ from, to }, { emitEvent: false });
            // }
        }
    }

    public registerOnChange(fn: (hourRange: string) => void): void {
        this.hourForm.valueChanges.pipe(untilDestroyed(this)).subscribe((formValues) => {
            const from = formValues.from;

            if (from) {
                fn(`${from}`);
            }
        });
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    // public setDisabledState(disabled: boolean) {
    //     disabled ? this.hourForm.disable() : this.hourForm.enable();
    // }

    /* eslint-disable @typescript-eslint/no-unsafe-assignment */
    private initForm() {
        this.hourForm = new FormGroup<HourForm>({
            from: new FormControl(null, [Validators.required])
        });
    }

    private initDropdownItems() {
        const hours: DropdownItem<string>[] = [];

        for (let i = 0; i < 24; i++) {
            //const value = i.toString().padStart(2, '0');
            const label = `${i.toString().padStart(2, '0')}:00`;

            hours.push({
                value: label,
                label
            });
        }

        this.hours = hours;
    }
}
